import { api } from "@/api/axios.ts";
import {
  ApiReportingDetailsInput,
  ApiReportingSalaryDetails,
} from "@/types/reporting/reporting.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";

export const reportingApi = {
  details(input: ApiReportingDetailsInput, signal?: AbortSignal) {
    return api.post<ApiPagedData<ApiReportingSalaryDetails>>(
      `/api/v1/reporting/details`,
      input,
      signal
    );
  },
  detailsExport(input: ApiReportingDetailsInput, signal?: AbortSignal) {
    return api.post<BlobPart>(`/api/v1/reporting/details`, input, signal, {
      responseType: "blob",
    });
  },
};
